module.exports = __webpack_public_path__ + "img/LOGO_NEU_ADMINPANEL.a3841d8b.svg";